<template>
	<div>
		<h6>Piqwise facturen</h6>

		<vs-row class="mt-5">
			<vs-col class="w-1/3">
				<vx-tooltip text="Vertuur factuur">
					<vs-button id="sendModuleInvoiceButton" @click.native="sendModuleInvoice()">
						<font-awesome-icon :icon="['fas', 'paper-plane']"/>
					</vs-button>
				</vx-tooltip>
			</vs-col>
			<vs-col class="w-1/3">
				<vx-tooltip text="Download factuur" position="top">
					<vs-button id="printModuleInvoiceButton" @click.native="downloadModuleInvoice()">
						<font-awesome-icon :icon="['fas', 'file-pdf']"/>
					</vs-button>
				</vx-tooltip>
			</vs-col>
		</vs-row>
	</div>

</template>

<script>
import apiClient from '@/services/apiClient';
import {mapGetters} from 'vuex';
import {format} from 'date-fns';

export default {
	name: "moduleInvoice",
	props: {
		order: {
			required: true,
		}
	},
	computed: {
		...mapGetters({
			isModuleInvoiceEnabled: 'dashboard/moduleInvoiceEnabled',
		}),
	},
	methods: {
		sendModuleInvoice() {
			this.startSendLoading()

			const params = {
				'order_id': this.order.order.id,
				'type': 'module_invoice'
			}

			apiClient.post('orders/invoice/send', params).then(response => {
				this.$vs.notify({
					title: 'Gelukt',
					text: 'Factuur is opnieuw naar de klant verzonden.',
					color: 'success'
				});

				this.stopSendLoading()
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops',
					text: 'Het verzenden van de factuur is mislukt.',
					color: 'danger'
				});

				this.stopSendLoading()
				console.log(error)
			});
		},

		downloadModuleInvoice() {
			this.startDownloadLoading();

			const params = {
				'order_id': this.order.order.id,
				'type': 'module_invoice'
			}

			apiClient.get('orders/invoice/download', {
				params,
				responseType: 'blob'
			}).then(response => {

				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;

				link.setAttribute('download', this.order.order.type_id_visible + ' - ' + format(new Date(), 'Y-MM-dd_H:mm:ss') + '.pdf');
				document.body.appendChild(link);
				link.click();

				this.stopDownloadLoading();
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops',
					text: 'Het downloaden van de factuur is mislukt.',
					color: 'danger'
				});
				this.stopDownloadLoading()
				console.log(error)
			});
		},

		startSendLoading() {
			this.$vs.loading({
				container: '#sendModuleInvoiceButton',
				scale: 0.45
			})
		},
		stopSendLoading() {
			this.$vs.loading.close('#sendModuleInvoiceButton > .con-vs-loading')
		},
		startDownloadLoading() {
			this.$vs.loading({
				container: '#printModuleInvoiceButton',
				scale: 0.45
			})
		},
		stopDownloadLoading() {
			this.$vs.loading.close('#printModuleInvoiceButton > .con-vs-loading')
		}

	}
}
</script>
